/**
 * Removes oidc related parameters from the provided url. This should be used
 * when redirecting to keycloak to avoid redirect loops.
 * @param originalUrl The url that should be cleaned
 */
export const stripOidcParams = (originalUrl: string) => {
    const url = new URL(originalUrl);

    // Remove unwanted oidc parameters
    url.searchParams.delete("session_state");
    url.searchParams.delete("state");
    url.searchParams.delete("code");

    return url.toString();
};
